import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="6"
    viewBox="0 0 10 6"
    fill="none"
  >
    <path
      d="M1 5.52076L4.98502 1.479L9 5.52076"
      stroke="#6A6783"
      strokeMiterlimit="10"
    />
  </svg>,
  "ChevronUp"
);
